import styled from "styled-components";

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const Wrapper = styled.div`
  width: 100%;

  @page {
    size: letter landscape;
    margin: 0.4in 0.5in 0.6in;

    @bottom-right {
      content: "Page " counter(page) " of " counter(pages);
      font-family: ${FONT_STACK};
      font-size: 9px;
      color: #555;
    }
  }

  @media print {
    margin: 0;
    padding: 16px 18px;
    display: block;
    width: 100%;
    height: auto;
    color: #000;
    border: 1px solid #000;
    box-sizing: border-box;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;

    & h1 {
      font-size: 22px;
      font-weight: 800;
    }
    & ul li {
      font-size: 11px;
    }
    & table {
      font-size: 10px;
    }
  }
`;

export default Wrapper;
